import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DetailBeneficiaireComponent } from './detail-beneficiaire/detail-beneficiaire.component';
import { BeneficiaireFormComponent } from './beneficiaire-form/beneficiaire-form.component';
import { ListBeneficiaireComponent } from './list-beneficiaire/list-beneficiaire.component';
import { BeneficiaireModalDetailFormationComponent } from './modal/beneficiaire-modal-detail-formation/beneficiaire-modal-detail-formation.component';
import { BeneficiaireModalAjoutFormComponent } from './modal/beneficiaire-modal-ajout-form/beneficiaire-modal-ajout-form.component';
import { NgxEditorModule } from 'ngx-editor';
import { FilterBeneficiaireByNamePipe } from 'src/app/shared/pipes/filter-beneficiaire-by-name/filter-beneficiaire-by-name.pipe';

@NgModule({
	declarations: [
		DetailBeneficiaireComponent,
		BeneficiaireFormComponent,
		ListBeneficiaireComponent,
		BeneficiaireModalDetailFormationComponent,
		BeneficiaireModalAjoutFormComponent
	],
	imports: [SharedModule, NgxEditorModule],
	providers: [FilterBeneficiaireByNamePipe]
})
export class BeneficiairesModule {}
